(() => {
  const selector = '[data-serbal-editorial-zoom]';

  const clamp = (value) => Math.min(1, Math.max(0, value));
  const easeOut = (value) => 1 - Math.pow(1 - value, 3);

  function initialise(section) {
    if (!(section instanceof HTMLElement) || section.dataset.serbalEditorialReady === 'true') return;
    // Shopify's editor can mount a selected section without an accurate viewport
    // position. Keep its text visible there; the live storefront still animates.
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    section.dataset.serbalEditorialReady = 'true';
    let active = false;
    let frame = null;

    const update = () => {
      frame = null;
      if (!active) return;

      const bounds = section.getBoundingClientRect();
      const viewport = window.innerHeight || document.documentElement.clientHeight;
      const zoomProgress = clamp((viewport - bounds.top) / (viewport + bounds.height * 0.3));
      const reveal = easeOut(clamp((viewport * 0.82 - bounds.top) / (viewport * 0.42)));
      const ctaReveal = easeOut(clamp((reveal - 0.28) / 0.72));

      section.style.setProperty('--serbal-editorial-zoom', (1 + zoomProgress * 0.08).toFixed(3));
      section.style.setProperty('--serbal-editorial-reveal', reveal.toFixed(3));
      section.style.setProperty('--serbal-editorial-cta-reveal', ctaReveal.toFixed(3));
      section.style.setProperty('--serbal-editorial-heading-y', `${((1 - reveal) * 24).toFixed(2)}px`);
      section.style.setProperty('--serbal-editorial-cta-y', `${((1 - ctaReveal) * 18).toFixed(2)}px`);
    };

    const requestUpdate = () => {
      if (!frame) frame = window.requestAnimationFrame(update);
    };

    const bounds = section.getBoundingClientRect();
    const viewport = window.innerHeight || document.documentElement.clientHeight;
    active = bounds.top < viewport && bounds.bottom > 0;
    if (active) update();
    section.classList.add('serbal-editorial--scroll-animated');

    const observer = new IntersectionObserver((entries) => {
      active = entries.some((entry) => entry.isIntersecting);
      if (active) requestUpdate();
    }, { rootMargin: '10% 0px' });

    observer.observe(section);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  }

  function initialiseIn(scope) {
    if (!scope) return;
    if (scope.matches?.(selector)) initialise(scope);
    scope.querySelectorAll?.(selector).forEach(initialise);
  }

  const boot = () => initialiseIn(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseIn(event.target));
})();
